import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
  Custom controller to extend and scale the 'react-jw-player' library for future updates.
*/

import { EVENT_ACTIONS } from '../../constants';
class JWPlayerController {
  constructor({
    emitEvent: _emitEvent
  }) {
    _defineProperty(this, "setPlayer", player => {
      this.player = player;
    });
    _defineProperty(this, "setErrorHandler", setError => {
      this.setError = setError;
    });
    _defineProperty(this, "onError", ({
      message
    }) => {
      this.error = message;
    });
    _defineProperty(this, "onSetupError", ({
      message
    }) => {
      this.error = message;
    });
    _defineProperty(this, "doEmitEvent", action => {
      const {
        emitEvent
      } = this;
      if (emitEvent) {
        const {
          mediaid: videoId
        } = this.player.getPlaylistItem();
        emitEvent({
          action,
          videoId
        });
      }
    });
    _defineProperty(this, "onComplete", event => {
      this.doEmitEvent(EVENT_ACTIONS.ENDED);
    });
    _defineProperty(this, "onPause", event => {
      this.doEmitEvent(EVENT_ACTIONS.PAUSED);
    });
    _defineProperty(this, "onPlay", event => {
      this.doEmitEvent(EVENT_ACTIONS.PLAYING);
    });
    this.player = null;
    this.error = null;
    this.emitEvent = _emitEvent;
  }
  get events() {
    return {
      play: this.onPlay,
      pause: this.onPause,
      error: this.onError,
      complete: this.onComplete,
      setupError: this.setupError
    };
  }
}
export default JWPlayerController;
//# sourceMappingURL=JWPlayerController.js.map